/**
 * Pure helpers for deriving annotationIds to export from the Project Progress grid payload
 * returned by GET projects/:folderId/progress/all.
 */

/**
 * @typedef {{ items?: Array<{ itemId: string }>, users?: Array<{ userId: string, itemProgress?: Array<{ itemId: string, annotationId?: string }> }> }} ProgressAllPayload
 *
 * @typedef {{ type: 'cell', itemId: string, userId: string }
 *   | { type: 'row', itemId: string }
 *   | { type: 'col', userId: string }
 *   | { type: 'all' }
 * } ExportScope
 */

/**
 * @param {ProgressAllPayload} payload
 * @param {ExportScope} scope
 * @returns {string[]} de-duplicated list of annotationIds (strings)
 */
export function collectAnnotationIds(payload, scope) {
    const users = Array.isArray(payload?.users) ? payload.users : [];
    const out = new Set();

    function add(id) {
        if (id == null) return;
        const s = String(id).trim();
        if (!s) return;
        out.add(s);
    }

    if (!scope || typeof scope !== 'object') return [];

    if (scope.type === 'all') {
        users.forEach((u) => {
            (u.itemProgress || []).forEach((cell) => add(cell?.annotationId));
        });
        return Array.from(out);
    }

    if (scope.type === 'col') {
        const uid = String(scope.userId);
        const u = users.find((x) => String(x.userId) === uid);
        (u?.itemProgress || []).forEach((cell) => add(cell?.annotationId));
        return Array.from(out);
    }

    if (scope.type === 'row') {
        const iid = String(scope.itemId);
        users.forEach((u) => {
            const cell = (u.itemProgress || []).find((c) => String(c?.itemId) === iid);
            add(cell?.annotationId);
        });
        return Array.from(out);
    }

    if (scope.type === 'cell') {
        const iid = String(scope.itemId);
        const uid = String(scope.userId);
        const u = users.find((x) => String(x.userId) === uid);
        const cell = (u?.itemProgress || []).find((c) => String(c?.itemId) === iid);
        add(cell?.annotationId);
        return Array.from(out);
    }

    return [];
}

